export default __webpack_public_path__ + "static/media/Strugani 3.a314b741.jpg";